module.exports = __webpack_public_path__ + "static/media/Tom Alterman.e8a73652.png";